<template>
    <div class="apply-admission">
        <div class="apply-admission-wrap accent-primary-bs bg-white bd-type1 accent-primary-bd">
            <div class="apply-admission-inner">
                <h2 class="title text-center"><span class="home-tx">Sign in</span></h2>

                <!-- User/Pass Login -->
                <div v-if="!useExternalAuthProvider">
                    <div class="caption text-center caption-spacing home-tx">
                        If you don't have an account yet <br />
                        <router-link class="register-link" to="/auth/register">Register here</router-link>
                    </div>

                    <div>
                        <div class="apply-sent apply-sent-style1" style="padding-top:30px">
                            <div class="form-sent-main">
                                <input :class="{ 'not-valid': v_email }" v-model="email" type="text" placeholder="Enter email address...">
                            </div>
                        </div>

                        <div class="apply-sent apply-sent-style1">
                            <div class="form-sent-main">
                                <input :class="{ 'not-valid' : v_password }" v-model="password" type="password" placeholder="Enter password ...">
                            </div>
                            <div class="login-button-row">
                                <button v-on:click="login" class="sign-up-main btn-site-primary" href="#loader-modal" data-toggle="modal">Sign In</button>
                            </div>
                        </div>

                        <div v-if="v_summary" class="alert alert-danger" style="text-align: center;">
                            {{ v_summary }}
                        </div>

                        <div class="caption text-center caption-spacing home-tx">
                            Forgot your password?
                            <router-link class="register-link" to="/auth/forgot">Reset it here</router-link>
                        </div>
                    </div>
                </div>

                <!-- Entra Login -->
                <div v-else>
                    <div class="caption text-center caption-spacing home-tx">
                        Use your work Microsoft account to sign in.
                    </div>
                    <div class="apply-sent apply-sent-style1" style="padding-top:0px">
                        <div class="form-sent-main" style="text-align:center">
                            <button v-on:click="loginEntra" class="sign-up-main btn-site-primary microsoft-button">
                                <span class="microsoft-icon"></span>
                                Sign in with Microsoft
                            </button>
                        </div>
                    </div>

                    <div v-if="v_summary" class="alert alert-danger" style="text-align: center; margin-top: 20px;">
                        {{ v_summary }}
                    </div>

                    <div class="caption text-center home-tx" style="margin-top: 10px">
                        If you can’t sign in, contact your administrator.
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style scoped>
    .apply-admission-wrap {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
    }

    .apply-admission .form-sent-main input {
        color: #000 !important;
        background: #fff !important;
    }

    .not-valid {
        border-color: rgb(255, 95, 96);
        border-width: 3px;
    }

    .caption-spacing {
        margin-top: 10px;
        margin-bottom: 18px;
        line-height: 1.4;
    }

    .apply-sent .form-sent-main input {
        width: 100%;
        box-sizing: border-box;
    }

    .sign-up-main.btn-site-primary,
    .btn.btn-site-primary {
        min-width: 240px;
        padding: 10px 22px;
        font-size: 18px;
        line-height: 1.2;
    }

    .login-button-row {
        text-align: center;
        margin-top: 25px;
    }

    .alert-danger {
        margin-top: 15px;
        padding: 10px 12px;
        border-radius: 4px;
    }

    .register-link {
        text-decoration: underline;
        font-size: 20px;
    }

    .microsoft-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding-left: 22px;
        padding-right: 22px;
    }

    .microsoft-icon {
        width: 18px;
        height: 18px;
        display: inline-block;
        background-size: 18px 18px;
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'><rect x='0' y='0' width='8' height='8' fill='%23F25022'/><rect x='10' y='0' width='8' height='8' fill='%237FBA00'/><rect x='0' y='10' width='8' height='8' fill='%2300A4EF'/><rect x='10' y='10' width='8' height='8' fill='%23FFB900'/></svg>");
    }
</style>

<script>
    import { saveEntraConfiguration, getMsalInstance } from '../auth/entraMsal'

    export default {
        name: 'LoginComponent',
        data: function () {
            return {
                email: "",
                password: "",
                v_email: false,
                v_password: false,
                v_summary: ""
            }
        },
        computed: {
            siteDesign() {
                return this.$store.getters.getSiteDesign;
            },
            useExternalAuthProvider() {
                return this.siteDesign?.useExternalAuthProvider === true;
            }
        },
        methods: {
            validate: function () {
                this.v_email = false;
                this.v_password = false;
                this.v_summary = null;

                if (!this.isValidEmail(this.email)) {
                    this.v_summary = "Please enter a valid email address";
                    this.v_email = true;
                    return false;
                }

                if (!this.isNotEmpty(this.password)) {
                    this.v_summary = "Please enter a valid password with at least 6 characters";
                    this.v_password = true;
                    return false;
                }

                return true;
            },
            async login() {
                try {
                    if (this.validate()) {
                        var userState = await this.web('/auth/login', "Logging you in", { email: this.email, password: this.password }, [400]);
                        this.$store.commit("setUserState", userState);
                    }
                }
                catch (e) {
                    console.error(e);
                    if (e.response && e.response.status == 400) {
                        this.v_summary = e.response.data;
                    }
                }
            },
            async loginEntra() {
                const tenantId = this.siteDesign.entraTenantID
                const clientId = this.siteDesign.entraClientID

                if (!tenantId || !clientId) {
                    this.v_summary = 'Entra is not configured for this site (missing tenantId/clientId).'
                    return
                }

                saveEntraConfiguration(tenantId, clientId)
                const msalInstance = getMsalInstance()
                return msalInstance.loginRedirect({ scopes: ['openid', 'profile', 'email'], prompt: 'login' })
            }
        }
    }
</script>